module.exports = __webpack_public_path__ + "img/comp-lenovo.1592cd13.svg";